import { apiUrl } from '../config';
import React, { useState } from 'react';
import { fetchData } from '../utils/api';
import { useLanguage } from '../LanguageContext';
import { getNumberOfDays } from '../utils/dynamic';

const BookingFormComponent = ({ room, checkIn, checkOut, onClose }) => {
  const initialGuests = Array.from(
    { length: room.id === 1 ? 2 : room.capacity },
    () => ({
      full_name: '',
      passport_serial_number: '',
      passport_serial_of_number: '',
    })
  );

  const [guests, setGuests] = useState(initialGuests);
  const [bookingData, setBookingData] = useState({...room, phone_number: ''});
  const [isDisabled, setIsDisabled] = useState(false);

  const [message, setMessage] = useState(null);
  const { language } = useLanguage();

  const payAtBank = async () => {
    setIsDisabled(true)
    const requestData = {
      'check_in': checkIn,
      'check_out': checkOut,
      'room_id': bookingData.id,
      'phone_number': bookingData.phone_number,
      'guests': guests,
    }
    if (requestData.room_id) {
      try {
        const token = localStorage.getItem('accessToken');
        const response = await fetchData(`${apiUrl}/api/${language}/payment`, "POST", token, {body: requestData})
        if (response.request.status === 0) {
          window.location.href = response.request.data.formUrl;
        } else {
          setMessage(response.request.message)
          // Включаем кнопку снова через 3 секунды
          setTimeout(() => setIsDisabled(false), 3000);
        }
      } catch (error) {
        console.error("Ошибка при перенаправлении на банк: ", error)
        // console.error("Ошибка при перенаправлении на банк.")
      }
    }
  }

  // Обработчик изменений для гостя
  const handleGuestChange = (index, field, value) => {
    const updatedGuests = [...guests];
    updatedGuests[index][field] = value;
    setGuests(updatedGuests);
  };
  
  // // Добавление гостя
  const addGuest = () => {
    if (guests.length == 1 && room.id == 1) {
      setGuests([...guests, { full_name: '', passport_serial_number: '', passport_serial_of_number: '' }]);
    }
  };

  // // Удаление гостя
  const removeGuest = (index) => {
    if (guests.length > 1 && room.id == 1) {
      setGuests(guests.filter((_, i) => i !== index));
    }
  };

  // Обработчик изменений для других полей
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setBookingData({ ...bookingData, [name]: value });
  };

  const langs = {
    'ru': {
      'full_name': "Имя и фамилия гостя",
      'phone_number': "Номер телефона",
      'passport_serial_of_number': "Серия паспорта гостя",
      'passport_serial_number': "Серийный номер паспорта гостя",
      'cancellation_terms': "Обязательно ознакомьтесь с правилами отмены брони!",
      'booking_service': `Услуга бронирования:`,
      'room_service': `Услуга номера (суток: ${getNumberOfDays(checkIn, checkOut)}):`,
      'total_amount': `Сумма для оплаты онлайн:`,
      'check_in': "Дата заезда:",
      'check_out': "Дата выезда:",
      'room_type': "Тип номера:",
      'capacity': "Количество гостей которые могут разместиться в номере:",
      'rooms_count': "Количество комнат в номере:",
      'guests_info': "Для бронирования номера возврат оплаты не производится!",
      'payment_info': "Оплата производится онлайн",
      'guests_fields': "При бронировании номера через наш сайт обязательно указывайте личные данные тех гостей, которые будут проживать в номере.",
      'minor': "Уважаемые гости! Обращаем ваше внимание, что несовершеннолетние граждане не могут быть размещены в номере без сопровождения совершеннолетних родственников, даже если бронирование было оформлено на их имя.",
      'only_booking': "только за бронирование",
      'abort_attention': "В случае отмены брони за 72 часа, стоимость за проживание возвращается, иначе возврат средств осуществить невозможно.",
      // 'abort_attention': "В случае отмены брони за 72 часа, стоимость за проживания первых суток возвращается, иначе возврат средств осуществить невозможно.",
      'smoking_prohibited': "Курение запрещено",
      'confirm_booking': "Оплатить номер (переход на станицу банка)",
      // 'confirm_booking': "Подтвердить бронирование (переход на станицу банка)",
      'add_guest': "Добавить гостя",
      'remove_guest': "Удалить гостя",
      'payment_at_checkin': "Оплата за проживание производится по прибытии в отель!",
      'payment_at_checkin_othersperiod': "Оплата за проживание за оставшиеся дни производится по прибытии в отель!"
    },
    'tm': {
      'full_name': "Myhmanyň ady we familiýasy",
      'phone_number': "Telefon belgisi",
      'passport_serial_of_number': "Myhmanyň pasportynyň seriýa",
      'passport_serial_number': "Myhmanyň pasportynyň belgisi",
      'cancellation_terms': "Bent etmegiň düzgünleri bilen hökman tanyş boluň!",
      'booking_service': `Bron etmek hyzmaty:`,
      'room_service': `Oteliň hyzmaty (gün: ${getNumberOfDays(checkIn, checkOut)}):`,
      'total_amount': `Onlaýn tölemeli mukdar:`,
      'check_in': "Giriş senesi:",
      'check_out': "Çykyş senesi:",
      'room_type': "Otagyň görnüşi:",
      'capacity': "Otagda ýerleşip biljek myhmanlaryň sany:",
      'rooms_count': "Otagyň sany:",
      'guests_info': "Otagy bent (bron) etmek üçin tölenen töleg yzyna gaýtarylmaýar!",
      'payment_info': "Töleg onlaýn görnüşinde amala aşyrylýar",
      'guests_fields': "Online sahypamyzdan otagymyzy bent (bron) edeninizde şol otagda ýaşajak raýatyň hokmany öz maglumatlary ýazylmalydyr!",
      'minor': "Ýetginjek ýaşa ýetmedik raýat otagy bent (bron) eden ýagdaýynda ýany bilen ýetginjek ýaşa ýeten hossarlary bolmasa otaga ýerleşdirilmejekdigi barada size habar berýaris.",
      'only_booking': "diňe bron üçin töleg",
      'abort_attention': "Eger-de gelip bilmedik ýagdaýyňyzda, bent eden otagyňyzy 72 sagat öňünden ýatyrýandygyňyzy habar bermeli. Eger-de 72 sagatdan öň habar eden ýagdaýyňyzda töleg yzyna gaýtarylyp berilýar. 72 sagatdan giç habar berlen ýagdaýynda otaga edilen töleg yzyna gaýtarylmaýar.",
      'smoking_prohibited': "Çilim çekmek gadagandyr.", 
      'confirm_booking': "Otagyň tölegini etmek (bank saýtyna geçiş)",
      // 'confirm_booking': "Rezervasiýany tassykla (bank saýtyna geçiş)",
      'add_guest': "Myhman goşmak",
      'remove_guest': "Myhmany aýyrmak",
      'payment_at_checkin': "Ýaşaýyş üçin töleg myhmanhana gelip ýerleşeniňizden soň amala aşyrylýar!",
      'payment_at_checkin_othersperiod': "Оплата за проживание за оставшиеся дни производится по прибытии в отель!"
    },
    'en': {
      'full_name': "Guest's full name",
      'phone_number': "Phone number",
      'passport_serial_of_number': "Guest passport series",
      'passport_serial_number': "Guest passport number",
      'cancellation_terms': "Please be sure to read the cancellation policy!",
      'booking_service': `Booking service:`,
      'room_service': `Room service (days: ${getNumberOfDays(checkIn, checkOut)}):`,
      'total_amount': `Total amount for online payment:`,
      'check_in': "Check-in date:",
      'check_out': "Check-out date:",
      'room_type': "Room type:",
      'capacity': "Number of guests the room can accommodate:",
      'rooms_count': "Number of rooms in the unit:",
      'guests_info': "Payment is non-refundable for room booking!",
      'payment_info': "Payment is made online",
      'guests_fields': "When booking a room through our website, please make sure to provide the personal details of the guest who will be staying in the room.",
      'minor': 'Dear guests, please note that underage individuals cannot be accommodated in a room without being accompanied by adult relatives, even if the reservation was made in their name.',
      'only_booking': "for booking only.",
      'abort_attention': "In case of cancellation at least 72 hours in advance, the cost of the stay will be refunded. Otherwise, a refund is not possible.",
      'smoking_prohibited': "Smoking is prohibited",
      'confirm_booking': "Book a room (redirect to bank page)",
      // 'confirm_booking': "Confirm booking (redirect to bank page)",
      'add_guest': "Add Guest",
      'remove_guest': "Remove Guest",
      'payment_at_checkin': "Payment for accommodation is made upon arrival at the hotel!",
      'payment_at_checkin_othersperiod': "Оплата за проживание за оставшиеся дни производится по прибытии в отель!"
    }
  };

  const daysForExtraGuest = getNumberOfDays(checkIn, checkOut);
  const priceForExtraGuests = (guests.length > room.capacity) ? (guests.length - room.capacity) * 120 * daysForExtraGuest : 0;
  
  return (
    <div className="background-floor" id="bookingForm">
      <form className="booking-form container">
        <div className="pos-rel">
          <span className="closer-icon" onClick={() => onClose()}>X</span>
        </div>
        {/* Номер телефона */}
        <div className="form-group">
          <label htmlFor="phone_number">{langs[language].phone_number}:</label>
          <input type="tel" placeholder={"+993********"} value={bookingData.phone_number} id="phone_number" name="phone_number" required onChange={handleInputChange} />
        </div>
        
        {/* Динамические поля для гостей */}
        {/* {(room.id == 1 && guests.length == 1) && (
          <div className='booking-form__buttons'>
            <button type="button" className='button-booking button-booking-small' onClick={() => addGuest()}>
              {langs[language].add_guest || 'Add Guest'}
            </button>
          </div>
        )} */}

        <div className='booking-form__guests'>
          {guests.map((guest, index) => (
            <div key={index} className='booking-form__guests___guest'>
              {/* <!-- Имя и фамилия --> */}
              <div className="form-group">
                <label htmlFor="full_name">{index+1+"."} {langs[language].full_name}:</label>
                <input
                  type="text"
                  placeholder={langs[language].full_name}
                  value={guest.full_name}
                  id={`full_name_${index}`}
                  name={`full_name_${index}`}
                  required
                  onChange={(e) => handleGuestChange(index, 'full_name', e.target.value)}
                  />
              </div>
              {/* Серийный номер паспорта */}
              <div className="form-group">
                <label htmlFor="passport_serial_of_number">{langs[language].passport_serial_of_number}:</label>
                <select
                  type="text"
                  value={guest.passport_serial_of_number}
                  id={`passport_serial_of_number_${index}`}
                  name={`passport_serial_of_number_${index}`}
                  required
                  onChange={(e) => handleGuestChange(index, 'passport_serial_of_number', e.target.value)}
                  >
                    <option value="">Выберите</option>
                    <option value="BN">BN</option>
                    <option value="AS">AS</option>
                    <option value="AH">AH</option>
                    <option value="MR">MR</option>
                    <option value="LB">LB</option>
                    <option value="DZ">DZ</option>
                    <option value="SN">SN</option>
                  </select>
              </div>
              <div className="form-group">
                <label htmlFor="passport_serial_number">{langs[language].passport_serial_number}:</label>
                <input
                  type="text"
                  maxLength={8}
                  placeholder='******'
                  value={guest.passport_serial_number}
                  id={`passport_serial_number_${index}`}
                  name={`passport_serial_number_${index}`}
                  required
                  onChange={(e) => handleGuestChange(index, 'passport_serial_number', e.target.value)}
                  />
              </div>
              {/* {guests.length > 1 && room.id == 1 && (
                <button type="button" className='button-booking button-booking-small' onClick={() => removeGuest(index)}>
                  {langs[language].remove_guest || 'Remove Guest'}
                </button>
              )} */}
            </div>
          ))}
        </div>

        <ul className="booking-form__list-data">
          {bookingData.rooms_price_status !== 0 &&
            <li className="booking-form__list-data__item">
              <a className='booking-form__link-cancel' href='/api/client/cancellation-terms' title={langs[language].cancellation_terms}>
                {langs[language].cancellation_terms}
              </a>
            </li>
          }
            {bookingData.booking_price_status !== 0 &&
              <li className="booking-form__list-data__item red-text">
                {langs[language].guests_info}
              </li>
            }
            <li className="booking-form__list-data__item red-text">
              {langs[language].payment_info}{bookingData.rooms_price_status === 0 && `, ${langs[language].only_booking}`}
            </li>
            <li className="booking-form__list-data__item red-text">
              {langs[language].minor}
            </li>
            <li className="booking-form__list-data__item red-text">
              {langs[language].guests_fields}
            </li>
            <li className="booking-form__list-data__item">
              {langs[language].total_amount} <span className="fw-b">
                {(bookingData.booking_price_status !== 0 && parseInt(bookingData.booking_price)) + (bookingData.rooms_price_status !== 0 && parseInt(bookingData.price) + priceForExtraGuests)} TMT
              </span>
            </li>
          {bookingData.booking_price_status !== 0 &&
          <li className="booking-form__list-data__item">
            {langs[language].booking_service} <span className="fw-b">{bookingData.booking_price} TMT</span>
          </li>
          }
          <li className="booking-form__list-data__item">
            {langs[language].room_service} <span className="fw-b">
              {parseInt(bookingData.price_full_period) + priceForExtraGuests} TMT
              {bookingData.rooms_price_status === 0 && bookingData.room_price_first_day === 0 &&
                ` - ${langs[language].payment_at_checkin}`
              }
              {bookingData.rooms_price_status === 1 && bookingData.room_price_first_day === 1 &&
                ` - ${langs[language].payment_at_checkin_othersperiod}`
              }
              </span>
          </li>
          <li className="booking-form__list-data__item">
            {langs[language].check_in} <span className="fw-b">{checkIn} 14:00</span>
          </li>
          <li className="booking-form__list-data__item">
            {langs[language].check_out} <span className="fw-b">{checkOut} 12:00</span>
          </li>
          <li className="booking-form__list-data__item">
            {langs[language].room_type} <span className="fw-b">{room.translations.room_type}</span>
          </li>
          <li className="booking-form__list-data__item">
            {langs[language].capacity} <span className="fw-b">{room.capacity}</span>
          </li>
          <li className="booking-form__list-data__item">
            {langs[language].rooms_count} <span className="fw-b">{room.rooms_count}</span>
          </li>
          {bookingData.rooms_price_status !== 0 &&
            <li className="booking-form__list-data__item red-text">{langs[language].abort_attention}</li>
          }
          <li className="booking-form__list-data__item">{langs[language].smoking_prohibited}</li>
        </ul>

        <h3 className='error-message'>{message && message}</h3>

        {/* Кнопка для подтверждения бронирования */}
        <button type="button" className="button-booking" disabled={isDisabled} onClick={() => payAtBank(bookingData)}>
          {isDisabled && "Пожалуйста подождите..."}
          {!isDisabled && langs[language].confirm_booking}
        </button>
      </form>
    </div>
  )
}

export default BookingFormComponent;